// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForwardMessage__container-d97985 {
  max-width: 100%;
  min-width: 136px;
  width: auto;
  white-space: nowrap;
  box-sizing: border-box;
}

.ForwardMessage__icon-f0e242 {
  flex-shrink: 0;
}

.ForwardMessage__title-a23d03 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.ForwardMessage__sender-name-dc7e0e {
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-spacing-subtitle-2);
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.ForwardMessage__theme-1-e679d0.ForwardMessage__container-d97985 {
  display: flex;
  align-items: center;
}

.ForwardMessage__theme-1-e679d0 .ForwardMessage__icon-f0e242 {
  fill: var(--chat-bubble-text-secondary);
}

.ForwardMessage__theme-1-e679d0 .ForwardMessage__title-a23d03 {
  color: var(--chat-bubble-text-secondary);
  margin: 0 6px 0 8px;
}

.ForwardMessage__theme-1-e679d0 .ForwardMessage__sender-name-dc7e0e {
  color: var(--chat-bubble-primary);
}

.ForwardMessage__theme-2-a9a3a1.ForwardMessage__container-d97985 {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: 4px 6px;
  gap: 5px;
  border-radius: 6px;
  background: var(--average-background);
}

.ForwardMessage__theme-2-a9a3a1 .ForwardMessage__icon-f0e242 {
  fill: var(--text-on-background);
}

.ForwardMessage__theme-2-a9a3a1 .ForwardMessage__title-a23d03 {
  color: var(--text-on-background);
}

.ForwardMessage__theme-2-a9a3a1 .ForwardMessage__sender-name-dc7e0e {
  color: var(--text-on-background);
}

.ForwardMessage__loader-cb66ae {
  margin-top: 1px;
  margin-bottom: 1px;
  margin-inline-start: 6px;
  margin-inline-end: 0px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/components/ForwardMessage/ForwardMessage.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;EACE,wCAAA;EACA,mBAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,qCAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  max-width: 100%;\n  min-width: 136px;\n  width: auto;\n  white-space: nowrap;\n  box-sizing: border-box;\n}\n\n.icon {\n  flex-shrink: 0;\n}\n\n.title {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.sender-name {\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-spacing-subtitle-2);\n  text-decoration: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.theme-1.container {\n  display: flex;\n  align-items: center;\n}\n\n.theme-1 .icon {\n  fill: var(--chat-bubble-text-secondary);\n}\n\n.theme-1 .title {\n  color: var(--chat-bubble-text-secondary);\n  margin: 0 6px 0 8px;\n}\n\n.theme-1 .sender-name {\n  color: var(--chat-bubble-primary);\n}\n\n.theme-2.container {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  padding: 4px 6px;\n  gap: 5px;\n  border-radius: 6px;\n  background: var(--average-background);\n}\n\n.theme-2 .icon {\n  fill: var(--text-on-background);\n}\n\n.theme-2 .title {\n  color: var(--text-on-background);\n}\n\n.theme-2 .sender-name {\n  color: var(--text-on-background);\n}\n\n.loader {\n  margin-top: 1px;\n  margin-bottom: 1px;\n  margin-inline-start: 6px;\n  margin-inline-end: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ForwardMessage__container-d97985`,
	"icon": `ForwardMessage__icon-f0e242`,
	"title": `ForwardMessage__title-a23d03`,
	"sender-name": `ForwardMessage__sender-name-dc7e0e`,
	"senderName": `ForwardMessage__sender-name-dc7e0e`,
	"theme-1": `ForwardMessage__theme-1-e679d0`,
	"theme1": `ForwardMessage__theme-1-e679d0`,
	"theme-2": `ForwardMessage__theme-2-a9a3a1`,
	"theme2": `ForwardMessage__theme-2-a9a3a1`,
	"loader": `ForwardMessage__loader-cb66ae`
};
module.exports = ___CSS_LOADER_EXPORT___;
